import {PhoneConfirmationWay, ProcessType} from "../../enum/phoneConfirm";
import {z} from "zod";
import {IErrorField, IErrorResult} from "../Basic/api";

export interface IPhoneConfirmationState {
    phone: string | null
    servicePhone: string | null
    ways: IConfirmationWays,
    selectedWay: PhoneConfirmationWay | null
    operation_id: number | null
    state_id: number | null
    confirmed: boolean
    errorConfirm: boolean
    confirmedByUserCall: boolean
    delay: number | null
    fetching: Record<string, boolean>
    confirmNumberModalLoader: boolean;
    error: IErrorField
    deadline?: {
        date?: string | null
    };

}

export const ConfirmationWayModel = z.object({
    id: z.nativeEnum(PhoneConfirmationWay),
    title: z.string(),
    description: z.string(),
})

export const ConfirmationWayModelArray = z.array(ConfirmationWayModel)

export type IConfirmationWays = z.infer<typeof ConfirmationWayModelArray>

export interface IGetConfirmationWaysParams {
    process_id: ProcessType
}

export interface IGetConfirmationWaysResult {
    data: IConfirmationWays
    error: IErrorResult
}

export interface IConfirmPhoneBySmsProps {
    confirmation_type_id: PhoneConfirmationWay
    phone_number: string
}

export const ConfirmPhoneBySmsModel = z.object({
    access_token: z.string(),
    retry_after: z.number(),
})
export type IConfirmPhoneBySms = z.infer<typeof ConfirmPhoneBySmsModel>

export interface IConfirmPhoneBySmsResult {
    data: IConfirmPhoneBySms
    error: IErrorResult
}

export interface IConfirmPhoneByEmailProps {
    email: string
    code?: string
}

export const ConfirmPhoneByEmailModel = z.object({
    operation_id: z.number(),
    state_id: z.number(),
})

export type IConfirmPhoneByEmail = z.infer<typeof ConfirmPhoneByEmailModel>

export interface IConfirmPhoneByEmailResult {
    data: IConfirmPhoneByEmail
    error: IErrorResult
}

export interface IConfirmPhoneByPushProps {
    token: string
    code?: string
}

export const ConfirmPhoneByPushModel = z.object({
    operation_id: z.number(),
    state_id: z.number(),
})
export type IConfirmPhoneByPush = z.infer<typeof ConfirmPhoneByPushModel>

export interface IConfirmPhoneByPushResult {
    data: IConfirmPhoneByPush
    error: IErrorResult
}

export interface IConfirmPhoneByFlashCallProps {
    phone_number: string
    confirmation_type_id: PhoneConfirmationWay
}

export const ConfirmPhoneByFlashCallModel = z.object({
    access_token: z.string(),
    retry_after: z.number(),
})

export type IConfirmPhoneByFlashCall = z.infer<typeof ConfirmPhoneByFlashCallModel>

export interface IConfirmPhoneByFlashCallResult {
    data: IConfirmPhoneByFlashCall
    error: IErrorResult
}

export interface IConfirmPhoneByUserCallProps {
    phone_number: string
    confirmation_type_id: PhoneConfirmationWay
}

export const ConfirmPhoneByUserCallModel = z.object({
    phone_number: z.string(),
    operation_id: z.number(),
    deadline: z.string().optional().nullable(),
    retry_after: z.number(),
    access_token: z.string(),
})

export type IConfirmPhoneByUserCall = z.infer<typeof ConfirmPhoneByUserCallModel>

export interface IConfirmPhoneByUserCallResult {
    data: IConfirmPhoneByUserCall
    error: IErrorResult
}


export interface IVerifyPhoneProps {
    operation_id: number
    code: string
}

export interface IVerifyPhoneByCallProps {
    operation_id: number
}

export const VerifyPhoneModel = z.object({
    state_id: z.number(),
})
export type IVerifyPhone = z.infer<typeof VerifyPhoneModel>

export interface IVerifyPhoneResult {
    data: IVerifyPhone
    error: IErrorResult
}
